import SectionHeading from "@/components/base/SectionHeading";
import ContentCard from "@/components/base/ContentCard";
import { getByType } from "@/utils/content";

export default function FeaturedPlots() {
  const plots = getByType("plot").slice(0, 3);

  return (
    <section className="w-full px-4 md:px-8 pb-14 md:pb-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading
          eyebrow="Story"
          title="精选剧情"
          desc="从归乡的列车到天台上的告白，逐集梳理《年轻的母亲3》的关键情节与人物转折。"
          actionTo="/category/plot"
          actionLabel="查看全部剧情"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {plots.map((item) => (
            <div key={item.id} className="animate-soft-in">
              <ContentCard item={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}